import { type Url, unsafeBrandUrl } from "../data-model/primitives.js";

export function hostnameOf(url: Url): string {
  return new URL(url).hostname.toLowerCase();
}

export function matchesAny(url: Url, hostnames: readonly string[]): boolean {
  const host = hostnameOf(url);
  return hostnames.some((h) => h.toLowerCase() === host);
}

export function resolveUrl(base: Url, relative: string): Url {
  return unsafeBrandUrl(new URL(relative, base).toString());
}

export function mapHostname(url: Url, hostMap: Readonly<Record<string, string>>): Url {
  const u = new URL(url);
  const mapped = hostMap[u.hostname.toLowerCase()];
  if (mapped === undefined) return url;
  u.hostname = mapped;
  return unsafeBrandUrl(u.toString());
}
